/**
 * Format IBAN
 * @param {string} value
 * @return {string}
 * @deprecated Use formatter from shared plain javascript library instead
 */
export function formatIBAN (value) {
  if (!value) return value;

  return value
    .replace(/^BE(.*)/i, 'BE$1')
    .replace(/^(BE\d{2})(\d+)$/i, '$1 $2')
    .replace(/^(BE\d{2} \d{4})(\d+)$/, '$1 $2')
    .replace(/^(BE\d{2} \d{4} \d{4})(\d+)$/, '$1 $2')
    .replace(/^(BE\d{2} \d{4} \d{4} \d{4})(\d+)$/, '$1 $2');
}

/**
 * Format NRN
 * @param {string} value
 * @return {string}
 * @deprecated Use formatter from shared plain javascript library instead
 */
export function formatNRN (value) {
  if (!value) return value;

  return value
    .replace(/^(\d{6})(\d+)$/, '$1 $2')
    .replace(/^(\d{6} \d{3})(\d+)$/, '$1 $2')
    .replace(/^(\d{6} \d{3} \d{2})(\d+)$/, '$1 $2');
}

/**
 * Format phone number
 * @param {string} value
 * @return {string}
 * @deprecated Use formatter from shared plain javascript library instead
 */
export function formatPhoneNumber (value) {
  if (!value) return value;

  return value
    .replace(/^(\+32)(\d+)$/, '$1 $2')
    .replace(/^(\+32 \d{3})(\d+)$/, '$1 $2')
    .replace(/^(\+32 \d{3} \d{2})(\d+)$/, '$1 $2')
    .replace(/^(\+32 \d{3} \d{2} \d{2})(\d+)$/, '$1 $2')
    .replace(/^(\+32 \d{3} \d{2} \d{2} \d{2})(\d+)$/, '$1 $2')
    .replace(/^(\d{3})(\d{2})(\d{2})(\d{2})$/, '+32 $1 $2 $3 $4');
}
